import styled from 'styled-components';
import { RIGHT_ALIGNED } from '../visitor-widget/constants/WidgetLocations';
import { useWidgetResizeContext } from '../contexts/WidgetResizeContext';
import { jsx as _jsx } from "react/jsx-runtime";
const CornerHandle = styled.div.withConfig({
  displayName: "WidgetResizeHandle__CornerHandle"
})(["position:absolute;top:0;", " width:16px;height:16px;cursor:", ";touch-action:none;z-index:10;"], ({
  $widgetLocation
}) => $widgetLocation === RIGHT_ALIGNED ? 'left: 0;' : 'right: 0;', ({
  $widgetLocation
}) => $widgetLocation === RIGHT_ALIGNED ? 'nwse-resize' : 'nesw-resize');
export default function WidgetResizeHandle() {
  const ctx = useWidgetResizeContext();
  if (!ctx) return null;
  const {
    onResizeHandlePointerDown,
    widgetLocation
  } = ctx;
  return /*#__PURE__*/_jsx(CornerHandle, {
    $widgetLocation: widgetLocation,
    onPointerDown: onResizeHandlePointerDown,
    "aria-hidden": "true",
    "data-test-id": "widget-resize-handle"
  });
}
WidgetResizeHandle.displayName = 'WidgetResizeHandle';